import React, {useContext, useEffect, useState} from "react";
import "react-datepicker/dist/react-datepicker.css";
import "./Filter.css";
import {Autocomplete, Button, Grid, TextField} from "@mui/material";
import {StateContext} from "../../../store";
import {museumApi} from "../../../services/MuseumServices";

const SetFilter = ({setFilters, visitorTypeOptions = [], onClearFilters}) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [year, setYear] = useState("");
  const [tickets, setTickets] = useState([]);
  const [meta, setMeta] = useState(null);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [museums, setMuseums] = useState([]);
  const [museumId, setMuseumId] = useState(null);
    const [ticketState, setTicketState] = useState([]);

  const ticketStates = [
    { value: 'initiated', label: 'Initiated' },
    { value: 'awaiting_payment', label: 'Awaiting Payment' },
    { value: 'completed', label: 'Completed' },
    { value: 'failed', label: 'Failed' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'used', label: 'Used' },
    { value: 'refund_requested', label: 'Refund Requested' },
    { value: 'refunded', label: 'Refunded' },
    { value: 'refund_rejected', label: 'Refund Rejected' },
    { value: 'expired', label: 'Expired' },
  ];

  useEffect(() => {
    getMuseumList();
  }, []);

  const getMuseumList = () => {
    museumApi('get').then(response => {
      setMuseums(response?.data);
    })
  }

  const handleFilterSubmit = async () => {
    const params = {};
    
    if (startDate && endDate) {
      const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      const formattedStartDate = new Date(startDate).toLocaleDateString('en-CA', options);
      const formattedEndDate = new Date(endDate).toLocaleDateString('en-CA', options);
      
      params.from_date = formattedStartDate;
      params.to_date = formattedEndDate;
    }
    
    if (museumId) {
      params.museum_id = museumId;
    }
    
    if (ticketState.length > 0) {
      params.state = ticketState;
    }
    
    setFilters(params);
  };

  const handleClearFilters = () => {
    console.log('SetFilter: Clearing all filters...');
    
    // Clear all filter states
    setStartDate(null);
    setEndDate(null);
    setMuseumId(null);
        setTicketState([]);
    
    // Clear filters in parent component
    console.log('SetFilter: Setting filters to empty object');
    setFilters({});
    
    // Clear localStorage
    console.log('SetFilter: Removing filters from localStorage');
    localStorage.removeItem('receptionist_filters');
    
    // Call parent component's clear filters function to force refresh
    if (onClearFilters) {
      console.log('SetFilter: Calling parent onClearFilters function');
      onClearFilters();
    } else {
      console.log('SetFilter: No onClearFilters function provided');
    }
  };

  return (
    <div className="ticket-filter-container">
      <Grid container spacing={2}>
        {/* First Row - Museum and Date Range */}
        {user?.username === 'admin' && (
          <Grid item lg={4} md={6} xs={12}>
            <Autocomplete
              id="combo-box-demo"
              options={museums}
              getOptionLabel={(option) => (option?.name)}
              onChange={(e, value) => {
                setMuseumId(value?.id);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Choose museum"
                  label="Select Museum"
                  name="museum_ids"
                />
              )}
              fullWidth
              size="small"
            />
          </Grid>
        )}
        
        {/* Date Range - From and To side by side */}
        <Grid item lg={2} md={3} xs={6}>
          <TextField
            type="date"
            label="From Date"
            placeholder="yyyy-mm-dd"
            variant="outlined"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            fullWidth
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item lg={2} md={3} xs={6}>
          <TextField
            type="date"
            label="To Date"
            placeholder="yyyy-mm-dd"
            variant="outlined"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            fullWidth
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        {/* Second Row - Ticket State */}
        <Grid item lg={3} md={6} xs={12}>
          <Autocomplete
            multiple
            id="ticket-state"
            options={ticketStates}
            getOptionLabel={(option) => option?.label || ''}
            value={ticketStates.filter(s => ticketState.includes(s.value))}
            onChange={(e, value) => {
              setTicketState(value.map(v => v.value));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Choose state"
                label="Ticket State"
                name="ticket_state"
              />
            )}
            fullWidth
            size="small"
          />
        </Grid>
        
        {/* Confirm Button */}
        <Grid item lg={1} md={6} xs={6}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilterSubmit}
            fullWidth
            size="medium"
            sx={{ height: '40px' }}
          >
            Apply
          </Button>
        </Grid>
        
        {/* Clear Button */}
        <Grid item lg={1} md={6} xs={6}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClearFilters}
            fullWidth
            size="medium"
            sx={{ height: '40px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default SetFilter;